// package: common
// file: common/user.proto

import * as common_user_feature from "../common/user_feature";

export const User = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.nickname != null) {
            if (object.nickname !== "") {
                message.nickname = String(object.nickname);
            }
        }
        if (object.avatar != null) {
            if (object.avatar !== "") {
                message.avatar = String(object.avatar);
            }
        }
        if (object.features != null) {
            if (!Array.isArray(object.features)) {
                throw TypeError("features: array expected");
            }
            if (object.features.length > 0) {
                message.features = [];
                for (let i = 0; i < object.features.length; ++i) {
                    message.features[i] = common_user_feature.UserFeature.encode(object.features[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            nickname: "",
            avatar: "",
            features: [],
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.nickname != null) {
            object.nickname = message.nickname;
        }
        if (message.avatar != null) {
            object.avatar = message.avatar;
        }
        if (message.features != null) {
            object.features = [];
            for (let i = 0; i < message.features.length; ++i) {
                object.features[i] = common_user_feature.UserFeature.decode(message.features[i]);
            }
        }
        return object;
    },
};


